import { useListContext, useRecordContext } from 'react-admin';

interface IProps {
  label?: string;
  sortable?: boolean;
}

export const IndexField = (_props: IProps) => {
  const record = useRecordContext();
  const { data, page = 1, perPage = 0 } = useListContext();

  if (!record || !data) {
    return null;
  }

  const index = data.findIndex((r) => r.id === record.id);
  if (index === -1) {
    return null;
  }

  return <>{(page - 1) * perPage + index + 1}</>;
};
